import { BetsQueryKeys } from '@/api/bets/queryKey';
import { useUserAccount } from '@/api/user/queries';
import { DetailedBet } from '@/models/detailed-bet';
import { GenericError } from '@/models/generic-error';
import { BetsSortAndFilterQuery } from '@/services/dto/bet/me/bets-sort-and-filter-query.query';
import {
  usePaginatedQuery,
  UsePaginatedQueryReturnProps,
} from '@starsoft/common/hooks';
import { PaginatedResponse } from '@starsoft/common/models';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useState } from 'react';
import { UseBetsMeQueryKeyProps } from '../props';
import { fetchBetsMe } from './service';

export function useBetsMeDefault(options?: BetsSortAndFilterQuery) {
  const { isAuthorized } = useUserAccount();
  const [page, setPage] = useState(1);

  const filter: BetsSortAndFilterQuery = {
    sortOrder: options?.sortOrder,
    aggregatorId: options?.aggregatorId,
    gameId: options?.gameId,
    limit: options?.limit ?? 15,
    page,
  };
  const queryKey: UseBetsMeQueryKeyProps = [BetsQueryKeys.Me, filter];

  const { data, isPending, fetchStatus, error, refetch, isFetching, ...rest } =
    useQuery<
      PaginatedResponse<DetailedBet>,
      AxiosError<GenericError>,
      PaginatedResponse<DetailedBet>,
      UseBetsMeQueryKeyProps
    >({
      queryFn: fetchBetsMe,
      queryKey,
      staleTime: 5 * 1000,
      //@ts-ignore
      enabled: isAuthorized && options?.enabled && options?.type === 'default',
      refetchOnWindowFocus: false,
    });

  const paginatedCallbacks = usePaginatedQuery({
    data,
    page,
    setPage,
    queryParams: {
      sortOrder: options?.sortOrder,
      aggregatorId: options?.aggregatorId,
      gameId: options?.gameId,
      limit: options?.limit ?? 15,
    },
  });

  return {
    isPending: (isPending || isFetching) && fetchStatus !== 'idle',
    error,
    refetch,
    data,
    bets: data?.data,
    isFetching,
    metadata: data?.metadata,
    ...rest,
    ...paginatedCallbacks,
    page,
  } as unknown as UsePaginatedQueryReturnProps<DetailedBet[]>;
}
